module.exports = __webpack_public_path__ + "images/loginBg.png?2f695d943a03e5eff6ebebed15b88509";


//////////////////
// WEBPACK FOOTER
// ./src/statics/img/loginBg.png
// module id = 613
// module chunks = 1